import React, { Component } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Grid, Segment, Header, Button, Icon, Message, MessageHeader } from 'semantic-ui-react';
import CitizenQuestionnaireSteps from './CitizenQuestionnaireSteps.jsx';
import CitizenNeedsForm from './CitizenNeedsForm.jsx';
import CitizenSuggestions from './CitizenSuggestions.jsx';
import Configuration from '../../config/Configuration.js';
import { authHeader, authHeaderPatch } from '../../helpers/auth-header.js';
import { withTranslation } from 'react-i18next';
import moment from 'moment';

class CitizenQuestionnaire extends Component {

    constructor() {
        super();
        this.config = new Configuration();
        this.state = {
            stage: 1,
            practitionerRoleId: '',
            patientId: '',
            familyName: '',
            givenName: '',
            postalCode: '',
            age: '',
            errorMsg: '',
            encounterId: '',
            questionnaireResponseId: '',
            questions: [],
            backgroundQuestions: [],
            socialNeedsQuestions: [],
            socialContextQuestions: [],
            specificQuestions: [],
            answers: [],
            selectedServices: [],
            requestedReferral: false,
            requestedLeaflets: false
        }
    }

    retrieveProfile() {
        return fetch(this.config.PATIENTS_URL + "/" + this.props.activeUser.uuid, {
            method: 'GET',
            headers: authHeader()
        })
            .then(response => {
                if (!response.ok) {
                    this.handleResponseError(response);
                }
                return response.json();
            })
            .then(citizen => {
                this.setState({
                    identifier: citizen.identifier,
                    familyName: citizen.familyName,
                    givenName: citizen.givenName,
                    phone: citizen.phone,
                    email: citizen.email,
                    gender: citizen.gender,
                    birthdate: moment(citizen.birthdate).format('YYYY-MM-DD'),
                    address: citizen.address
                });
                if (citizen.address) {
                    this.retrieveAddress(citizen.address.uuid);
                }
            })
            .catch(error => {
                this.handleError(error);
            });
    }

    retrieveAddress = (addressUuid) => {
        return fetch(this.config.ADDRESSES_URL + "/" + addressUuid, {
            method: 'GET',
            headers: authHeader()
        })
            .then(response => {
                if (!response.ok) {
                    this.handleResponseError(response);
                }
                return response.json();
            })
            .then(address => {
                this.setState({
                    addressCountry: address.country,
                    addressPostalCode: address.postalCode,
                });
            })
            .catch(error => {
                this.handleError(error);
            });
    }

    retrieveQuestionnaire(questionnaireId) {
        return fetch(this.config.QUESTIONNAIRES_URL + "/" + questionnaireId, {
            method: 'GET',
            headers: authHeader()
        })
            .then(response => {
                if (!response.ok) {
                    this.handleResponseError(response);
                }
                return response.json();
            })
            .then(json => {
                const questions = [];
                const questionnaireItems = json.questionnaireItemOutputListModel.questionnaireItems;
                for (var i = 0; i < questionnaireItems.length; i++) {
                    questions.push(questionnaireItems[i]);
                }
                this.setState({ questions: questions });
                return questions;
            })
            .catch(error => {
                this.handleError(error);
            });
    }

    createEncounter = (patientId, practionerRoleId) => {
        let pid = patientId;
        if (!patientId) {
            pid = this.state.patientId;
        }
        return fetch(this.config.ENCOUNTERS_URL, {
            method: 'POST',
            headers: authHeader(),
            body: JSON.stringify({
                subject: pid,
                participant: practionerRoleId,
                date: new Date(),
                type: this.config.ENCOUNTER_CONSULT_QUESTIONNAIRE
            })
        }).then(response => {
            if (!response.ok) {
                this.handleResponseError(response);
            } else {
                return response.json();
            }
        }).then(encounter => {
            this.setState({ encounterId: encounter.id });
        }).catch(error => {
            this.handleError(error);
        });
    }

    createQuestionnaireResponse = (questionnaireId) => {
        return fetch(this.config.QUESTIONNAIRE_RESPONSES_URL, {
            method: 'POST',
            headers: authHeader(),
            body: JSON.stringify({
                subject: this.props.activeUser.uuid,
                questionnaire: questionnaireId,
                authored: new Date(),
            })
        }).then(response => {
            if (!response.ok) {
                this.setState({ questionnaireResponseCreationError: true })
            } else {
                this.setState({ questionnaireResponseCreated: true });
                return response.json();
            }
        }).then(questionnaireResponse => {
            this.setState({ questionnaireResponseId: questionnaireResponse.id })
            this.registerAnswers(questionnaireResponse.id);
            return questionnaireResponse;
        }).then(questionnaireResponse => {
            this.setState({ stage: 3 })
        }).catch(error => {
            this.handleError(error);
        });
    }

    completeQuestionnaireResponse = () => {
        return fetch(this.config.QUESTIONNAIRE_RESPONSES_URL + "/" + this.state.questionnaireResponseId, {
            method: 'PATCH',
            headers: authHeaderPatch(),
            body: JSON.stringify({
                status: 'QuestionnaireComplete'
            })
        }).then(response => {
            if (!response.ok) {
                this.setState({ questionnaireResponseCompletionError: true })
            } else {
                this.setState({ questionnaireResponseCompleted: true });
                return response;
            }
        }).catch(error => {
            this.handleError(error);
        });
    }

    createQuestionnaireResponseItem = (responseId, itemId, answerId, notes) => {
        return fetch(this.config.QUESTIONNAIRE_RESPONSE_ITEMS_URL, {
            method: 'POST',
            headers: authHeader(),
            body: JSON.stringify({
                questionnaireResponse: responseId,
                questionnaireItem: itemId,
                chosenAnswer: answerId,
                notes: notes
            })
        }).then(response => {
            if (!response.ok) {
                this.setState({ questionnaireResponseCreationError: true })
            } else {
                this.setState({ questionnaireResponseCreated: true });
                return response.json();
            }
        }).catch(error => {
            this.handleError(error);
        });
    }

    registerConsent(healthcareService) {
        let practitionerRoleId = '';
        if (this.props.activeUser) {
            this.setState({
                practitionerRoleId: this.props.activeUser.uuid,
            });
            practitionerRoleId = this.props.activeUser.uuid;
        }
        return fetch(this.config.CONSENTS_URL, {
            method: 'POST',
            headers: authHeader(),
            body: JSON.stringify({
                status: "Active",
                scope: "patient-privacy",
                patient: this.state.patientId,
                performer: practitionerRoleId,
                organization: healthcareService.provider.uuid,
                policy: "limited"
            })
        }).then(response => {
            if (!response.ok) {
                this.handleResponseError(response);
            } else {
                return response.json();
            }
        }).catch(error => {
            this.handleError(error);
        });
    }

    registerServiceRequestConcepts(serviceRequestId, codableConceptId) {
        return fetch(this.config.SERVICEREQUESTS_CONCEPTS_URL, {
            method: 'POST',
            headers: authHeader(),
            body: JSON.stringify({
                codableConcept: serviceRequestId,
                serviceRequest: codableConceptId
            })
        }).then(response => {
            if (!response.ok) {
                this.handleResponseError(response);
            } else {
                return response.json();
            }
        }).catch(error => {
            this.handleError(error);
        });
    }

    registerServiceRequest(suggestion) {
        let intent = '';
        if (suggestion.healthcareService.referralMethod === "NONE") {
            intent = this.config.SERVICE_REQUEST_INTENT_SIGNPOSTING;
        }
        return fetch(this.config.SERVICEREQUESTS_URL, {
            method: 'POST',
            headers: authHeader(),
            body: JSON.stringify({
                encounter: this.state.encounterId,
                performer: suggestion.healthcareService.defaultAssignedHealthcareService.uuid,
                suggestion: suggestion.uuid,
                notes: this.state.socialContextAnswers,
                intent: intent
            })
        }).then(response => {
            if (!response.ok) {
                this.handleResponseError(response);
            } else {
                return response.json();
            }
        }).then(serviceRequest => {
            let id = serviceRequest.id;
            let codableConcepts = suggestion.codableConcepts;
            if (codableConcepts) {
                for (var i = 0; i < codableConcepts.length; i++) {
                    this.registerServiceRequestConcepts(id, codableConcepts[i].uuid);
                }
            }
        }).catch(error => {
            this.handleError(error);
        });
    }


    handleResponseError(response) {
        return {
            error: true,
            status: response.status
        };
    }

    handleError(error) {
        console.log(error.message);
    }

    setSelectedServices = (services) => {
        this.setState({ selectedServices: services });
    }

    setAnswers = (answers) => {
        this.setState({ answers: answers }, () => {
            this.registerQuestionnaireResponse(this.state.questionnaireId);
        });
    }

    componentDidMount() {
        this.retrieveProfile();
        this.retrieveQuestionnaire("36d0432f-58c1-4d40-a95d-114b8257f2f6");
    }

    registerAnswers = (questionnaireResponseId) => {

        const promises = this.state.answers.map(answer => {
            return this.createQuestionnaireResponseItem(
                questionnaireResponseId,
                answer.questionnaireItem.uuid,
                answer.uuid,
                null
            );
        });

        Promise.all(promises)
            .then(() => {
                this.completeQuestionnaireResponse();
            })
            .catch(error => {
                console.error("Fout bij het aanmaken van items:", error);
            });
    };

    registerQuestionnaireResponse = (questionnaireId) => {
        this.createQuestionnaireResponse(questionnaireId);
    }

    requestServices = (servicesToRequest) => {
        for (var i = 0; i < servicesToRequest.length; i++) {
            this.registerConsent(servicesToRequest[i].healthcareService);
            this.registerServiceRequest(servicesToRequest[i]);
            if (servicesToRequest[i].healthcareService.referralMethod === "email") {
                this.setState({ requestedReferral: true });
            } else if (servicesToRequest[i].healthcareService.referralMethod === "NONE") {
                this.setState({ requestedLeaflets: true });
            }
        }
    }

    previousStage = () => {
        this.setState({ stage: this.state.stage - 1 });
    }

    nextStage = () => {
        console.log("Go to stage: " + (this.state.stage + 1));
        // Go to next stage except for suggestions
        // That needs to be triggered after all answers are registered
        this.setState({ stage: this.state.stage + 1 });

    }

    getQuestions = () => {
        const { t } = this.props;
        if (this.state.stage === 1) {
            return <Segment>
                <Segment basic>
                    <Header size='small'>Waarom deze vragenlijst?</Header>
                    <Container text fluid size='small'>Met deze vragenlijst willen we beter begrijpen wat jij nodig hebt. Zo kunnen we je helpen om snel de juiste steun of activiteiten te vinden.</Container>
                    <Header size='small'>Hoe gebruiken we jouw antwoorden?</Header>
                    <Container text fluid size='small'>Je antwoorden blijven privé. We gebruiken ze alleen om suggesties te doen die passen bij jouw situatie.</Container>
                </Segment>
                <Button onClick={this.nextStage} icon labelPosition='right' color='blue'>
                    {t("Next")}
                    <Icon name='right arrow' />
                </Button>
            </Segment>;
        } else if (this.state.stage === 2) {
            return <CitizenNeedsForm
                nextStage={this.nextStage}
                previousStage={this.previousStage}
                questions={this.state.questions}
                answers={this.setAnswers}
                savedAnswers={this.state.answers} />;
        } else if (this.state.stage === 3) {
            return <CitizenSuggestions nextStage={this.nextStage}
                questionnaireResponseId={this.state.questionnaireResponseId}
                selectedServices={this.setSelectedServices}
                postalCode={this.state.postalCode}
                age={this.state.age} />;
        } else {
            return <Container>Oeps: {this.state.stage}</Container>;
        }
    }

    render() {
        return <Container>
            <Grid columns={5}>
                <Grid.Column width={1}>
                </Grid.Column>
                <Grid.Column width={4}>
                    <Container text style={{ marginTop: '1em' }}>
                        <CitizenQuestionnaireSteps stage={this.state.stage} patientName={this.state.givenName + " " + this.state.familyName} activeUser={this.props.activeUser} />
                    </Container>
                </Grid.Column>
                <Grid.Column width={10}>
                    <Container fluid style={{ marginTop: '1em' }}>
                        {this.getQuestions()}
                    </Container>
                </Grid.Column>
                <Grid.Column width={1}>
                </Grid.Column>
            </Grid >
        </Container>;
    }
}

function WithNavigateWrapper(props) {
    const navigate = useNavigate();
    const location = useLocation();
    return <CitizenQuestionnaire {...props} navigate={navigate} location={location} />;
}

export default withTranslation()(WithNavigateWrapper);
